module.exports = __webpack_public_path__ + "static/media/SaveTheChildren.d6a033d3.jpeg";